import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { CellEditingStoppedEvent, ColDef, ValueGetterParams, ValueFormatterParams, GridApi, IServerSideDatasource, IServerSideGetRowsParams } from 'ag-grid-community';
import { ObjectUnsubscribedError, Observable, catchError, filter, map, of } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Package, Position } from "../../models/inventory-positions.model"
import { WarehousePositionPackagesComponent } from '../warehouse-position-packages/warehouse-position-packages.component';
import { PositionDetailsModalComponent } from './position-details-modal/position-details-modal.component';

interface TestData {
  [key: string]: {
    [key: string]: {
      position_uuid: string;
      spot_number: string;
      package_uuid: string | null;
      contact_uuid: string | null;
      contact_organization: string | null;
      packaging_type: number | null;
    }[];
  };
}

@Component({
  selector: 'app-warehouse-area-details',
  templateUrl: './warehouse-area-details.component.html',
  styleUrls: ['./warehouse-area-details.component.scss']
})
export class WarehouseAreaDetailsComponent implements ICellRendererAngularComp {

  public detailCellRenderer: any = WarehousePositionPackagesComponent

  public gridReady = false;
  public themeClass: string = "ag-theme-ulaap";

  package_details: any[] = []
  package_form!: FormGroup

  showContent: boolean = false;

  positions: Position[] = []
  products: any[] = []

  params: any
  uuid: string | null = ''
  position_uuid: string | null = ''

  packages: Package[] = []

  public rowGroupPanelShow: "always" | "onlyWhenGrouping" | "never" = "always";

  lading_uuid: string | null = ''
  ladings_form!: FormGroup

  constructor(private http: HttpClient, private formBuilder: FormBuilder, private dialog: MatDialog) {
    this.package_form = this.formBuilder.group({
      contact_organization: [''],
      warehouse_name: [''],
      package_name: [''],
      length: [''],
      width: [''],
      height: [''],
      weight: ['']
    })

    this.ladings_form = this.formBuilder.group({
      alternate_reference: [''],
      lading_number: [''],
      pro_bill: [''],
      shipper_name: [''],
      consignee_name: [''],
      carrier_name: [''],
      customer_name: [''],
      shipper_locality: [''],
      consignee_locality: [''],
      load_start: [''],
      load_end: [''],
    })
  }

  agInit(params: any): void {

    this.params = params;
    this.packages = params.data.packages
    this.positions = params.positions
    this.uuid = params.uuid
    this.position_uuid = params.data.inventory_position_uuid

    // if (package_uuid) {
    //   const packages_url = `/api/inventory/inventory_warehouse_packages.php?uuid=${package_uuid}`;
    //   this.http.get<any>(packages_url).subscribe(response => {

    //     this.package_details = response
    //     this.package_form.get('contact_organization')?.setValue(response.contact_organization)
    //     this.package_form.get('package_name')?.setValue(response.package_name)
    //     this.package_form.get('warehouse_name')?.setValue(response.inventory_warehouse_name)
    //     this.package_form.get('length')?.setValue(response.length)
    //     this.package_form.get('width')?.setValue(response.width)
    //     this.package_form.get('height')?.setValue(response.height)
    //     this.package_form.get('weight')?.setValue(response.weight)
    //     this.lading_uuid = response.lading_uuid

    //     const ladings_url = `/api/inventory/inventory_warehouse_ladings.php?uuid=${this.lading_uuid}`;

    //     if (this.lading_uuid) {
    //       this.http.get<any>(ladings_url).subscribe(response => {

    //         console.log('ladings list', response)

    //         this.ladings_form.get('alternate_reference')?.setValue(response.alternate_reference)
    //         this.ladings_form.get('lading_number')?.setValue(response.lading_number)
    //         this.ladings_form.get('pro_bill')?.setValue(response.pro_bill)
    //         this.ladings_form.get('shipper_name')?.setValue(response.shipper_name)
    //         this.ladings_form.get('consignee_name')?.setValue(response.consignee_name)
    //         this.ladings_form.get('carrier_name')?.setValue(response.carrier_name)
    //         this.ladings_form.get('customer_name')?.setValue(response.customer_name)
    //         this.ladings_form.get('shipper_locality')?.setValue(response.shipper_locality)
    //         this.ladings_form.get('consignee_locality')?.setValue(response.consignee_locality)
    //         this.ladings_form.get('load_start')?.setValue(response.load_start)
    //         this.ladings_form.get('load_end')?.setValue(response.load_end)

    //       })
    //     }

    //   })

    //   // const products_url = `/api/inventory/inventory_warehouse_products.php?uuid=${package_uuid}`;
    //   // this.http.get<any>(products_url).subscribe(response => {

    //   //   console.log('product list', response)
    //   //   this.products = response
    //   //   this.gridReady = true

    //   // })

    // }

    this.showContent = true

  }

  ngOnInit(): void {

  }

  private gridApi!: GridApi;

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  defaultColDef = {
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      caseSensitive: false,
    },
    autoHeight: true,
    cellClass: 'cell-wrap-text',
    resizable: true,
  };

  public autoGroupColumnDef: ColDef = {
    minWidth: 200,
  };

  // headers for the packages grid
  packageColumnDefs: ColDef[] = [
    { field: 'contact_organization', headerName: 'Contact Organization', cellRenderer: 'agGroupCellRenderer', enableRowGroup: true, width: 350 },
    { field: 'start_date', headerName: 'Start Date' },
    { field: 'end_date', headerName: 'End Date' },
    { field: 'model', enableRowGroup: true, headerName: 'Model' },
    { field: 'serial', enableRowGroup: true, headerName: 'Serial' },
    { field: 'packaging_type', headerName: 'Package Type' },
    { field: 'condition', headerName: 'Condition'},
    { field: 'image_thumbnail', headerName: 'Image'}
  ]

  // function to set the count of products using their row index
  countGetter(params: ValueGetterParams) {
    if (params.node && params.node.rowIndex !== null) {
      return params.node.rowIndex + 1
    }
    return ''
  }

  // Function to format the weight value
  formatWeight(params: any) {
    if (params.value != null) {
      // Format the value to two decimal places
      return Number(params.value).toFixed(2);
    } else {
      return ''; // Handle null or undefined values if necessary
    }
  }

  openModal(mode: string): void {
    // Open the modal dialog with the position details
    const dialogRef = this.dialog.open(PositionDetailsModalComponent, {
      width: '400px',
      data: {
        positions: this.positions,
        uuid: this.uuid,
        position_uuid: this.position_uuid,
        packages: this.packages,
        mode: mode
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result) {
        if (this.params.updateGridData) {
          this.params.updateGridData(); // Call the parent's updateGridData function
        }
      }
    });
  }

  refresh(params: any): boolean {
    return false;
  }

}
